//@import dependencies
import React, { useEffect, useState } from 'react'

import parse from 'html-react-parser';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from 'moment'
import shortId from 'shortid';
//@end

//@import components
import PublicAppContainer from 'app_components/layouts/public'
import IconComponent from 'app_components/commons/icons'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import OffercardCommon from 'app_components/commons/offercard';
import ContentInterestCardComponent from 'app_components/commons/contentInterestCard';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { Link } from 'react-router-dom';
//@end

// @import hooks
import { useTranslation } from 'react-i18next'
import { useColors } from 'app_hooks/useColors';
import useWindowWidth from 'app_hooks/useWindowWidth';
// @end

// @INFO Import types
import { ILanding } from 'app_types/admin/landings/landingTypes';
// @end

// @INFO Import services
import LandingService from 'app_services/admin/landings/landingService';
// @end

// @INFO Import Styles
import './../teachersScreen.scss'
import { customs } from 'app_config/globals';
import ForumSliderModule from 'app_components/modules/ForumSliderModule/ForumSliderModule';

const teachersImg = require('app_assets/images/resources/landing/teachers.jpg')

// @ADD Component types
interface ITeachersScreenLayoutProps {}

const TeachersScreenLayout: React.FC<ITeachersScreenLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [colors] = useColors()
  const { windowWidth } = useWindowWidth()
  const [landing, updateLanding] = useState<ILanding | undefined>(undefined)

  // @INFO Servicios
  const landingService = new LandingService()

  useEffect(() => {
    getLandingData()
  },[])

  /**
   * @INFO Obtener la data para la landing
   */
  const getLandingData = async () => {
    let httpParams: any = {
      slug: 'teacher'
    }
    const landingResponse = await landingService.fetchLandingData(httpParams)
    if (landingResponse) {
      updateLanding(landingResponse)
    }
  }

  const getNumberItems = () => {
    if(windowWidth < 576){
      return 1
    }
    if(windowWidth < 991){
      return 2
    }
    return 4
  }

  return(
    <PublicAppContainer>
      <div className='teachers_screen-layout'>
        <TextComponent
          type='subtitle'
        >
          Docentes
        </TextComponent>
        {landing?.landing?.title_page && (
          <TextComponent
            type='title'
            className='title-page-teachers'
          >
            {landing?.landing?.title_page}
          </TextComponent>
        )}
        {landing?.landing?.article && (
          <>
            {landing?.landing?.article?.coverFile && (
              // <div className="container-header-img" style={{backgroundImage: `url(${landing?.landing?.article?.coverFile})`}}></div>
              <img className="teachers-screen--image" src={landing?.landing?.article?.coverFile} alt="" />
            )}
            {landing?.landing?.article?.coverCaption && (
              <TextComponent
                type='text'
                style={{ color: 'var(--primary)', width: '100%'}}
                className="cover-caption"
              >
                Pie de foto: {landing?.landing?.article?.coverCaption}
              </TextComponent>
            )}
            {landing?.landing?.article?.title && (
              <TextComponent
                type='title'
                className='title-page-teachers'
              >
                {landing?.landing?.article?.title}
              </TextComponent>
            )}
            {landing?.landing?.article?.content && (
              <div className="container-text-columns">
                {parse(landing?.landing?.article?.content ? landing?.landing?.article?.content : '')}
              </div>
            )}
          </>
        )}
        {/* ==================================================== */}
        {/* Slider de capacitaciones */}
        {/* ==================================================== */}
        {landing?.landing?.trainings?.length ?
          <>
            <TextComponent
              type='title'
              className='title-page-teachers'
            >
              CAPACITACIONES INTERNAS
            </TextComponent>
            <Slider
              arrows={true}
              infinite={(landing?.landing?.trainings.length >= getNumberItems()) ? true : false}
              slidesToShow={getNumberItems()}
              nextArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleRight' width={24} color={colors.primary} />}/>}
              prevArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleLeft' width={24} color={colors.primary} />}/>}
            >
              {landing?.landing?.trainings.map((_item) => (
                <div
                  key={_item.slug}
                  className='container-offer-card-page'
                >
                  <OffercardCommon
                    // @ts-ignore
                    course={{
                      key: shortId.generate(),
                      _id: shortId.generate(),
                      // duration: 100,
                      elementType: 'training',
                      // @ts-ignore
                      extra_info: {
                        description: _item.description,
                        coverUrl: _item.attachedFile,
                      },
                      custom_training: {
                        modality: _item.modality,
                        city: _item.city
                      },
                      // @ts-ignore
                      program: {
                        name: _item.title,
                      },
                      startDate: moment(_item.start_date?.replace('T00:00:00.000Z','')).format('DD/MM/YYYY')
                    }}
                    share={`${customs.site}/teachers`}
                  />
                </div>
              ))}
            </Slider>
          </>
        :null}
        {/* ==================================================== */}
        {/* Slider de aprendizaje */}
        {/* ==================================================== */}
        <ForumSliderModule
          title={landing?.landing?.forums?.title}
          description={landing?.landing?.forums?.description}
        />
        {/* ==================================================== */}
        {/* Programación el linea */}
        {/* ==================================================== */}
        {landing?.landing?.scheduling?.length ?
          <>
              <div
                className='container-buttons-sheduling'
              >
                {landing?.landing?.scheduling.map((_schedule) => (
                  <div className="container-scheduling-item">
                  <TextComponent
                    type='title'
                    className='title-page-teachers'
                  >
                    {_schedule.title}
                  </TextComponent>
                  <Link
                    to={{
                      pathname: _schedule.attachedFile
                    }}
                    target='_blank'
                  >
                    <ButtonComponent
                      key={_schedule.unique}
                      variant='secondary'
                      style={{
                        width: 'fit-content'
                      }}
                    >
                      Descargar documento
                    </ButtonComponent>
                  </Link>
                  </div>
                ))}
              </div>
          </>
          :null}
      </div>
    </PublicAppContainer>
  )
}

// ======================================
// Flecha
// ======================================
const CustomArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      {props.icon}
    </div>
  );
}

export default TeachersScreenLayout
